export default "__VITE_ASSET__13Ks58Rp__"